// Create a new parser, used to parse XML.
const domParser = new DOMParser();

// getVastFromVastURL gets the vast XML from the given URL.
function getVastFromVastURL(url: string): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    // Try to fetch the URL.
    fetch(url)
      .then((response) => response.text()) // Handle the response as text (as it's XML).
      .then((str) => resolve(str)) // Everything works, resolve the promise.
      .catch((error: Error) => reject(Error(`Error while getting the VAST: ${error.message}`))); // Error, reject promise.
  });
}

// getMediafileFromVastURL returns the mediafile URL from a VAST URL.
export function getMediafileFromVastURL(vastURL: string): Promise<string> {
  // Create the promise for this function.
  return new Promise<string>((resolve, reject) => {
    // Check VAST URL validity.
    if (!vastURL) {
      return reject(Error('No VAST URL.'));
    }
    if (!vastURL.startsWith('https://')) {
      return reject(Error('Preview only handle HTTPS URL.'));
    }

    // Call the VAST URL to get the vast XML.
    getVastFromVastURL(vastURL)
      .then((vastXML: string) => {
        // Call OK. Parse the VAST XML.

        // 1. Parse the response's XML.
        const xmlDoc = domParser.parseFromString(vastXML, 'text/xml');

        // 2. Extract the mediafiles from the XML.
        const mediafiles = xmlDoc.getElementsByTagName('MediaFile');

        // 3. Try to get what's inside the CDATA of the media file tag.
        if (
          mediafiles.length === 0 ||
          !mediafiles[0].childNodes ||
          mediafiles[0].childNodes.length === 0
        ) {
          return reject(Error("The returned VAST doesn't contain any media file."));
        }
        const mediafileCDATA = (mediafiles[0].childNodes[0] as any).data;
        if (!mediafileCDATA || typeof mediafileCDATA !== 'string') {
          return reject(Error('The returned VAST media file CDATA is invalid.'));
        }

        // Everything went fine, resolve the promise with the media file's CDATA content.
        return resolve(mediafileCDATA);
      })
      .catch((reason) => {
        // Call not OK. Reject the promise.
        return reject(
          Error(`Cannot send the request: ${reason}. Maybe it's caused by the CORS policy.`),
        );
      });
  });
}
